export default function Products() {
  const products = [
    {
      title: 'VPN Solution',
      subtitle: 'Secure & Private Browsing',
      image: 'https://public.readdy.ai/ai/img_res/2f7628d9e2cd0f30dd148507867cf319.jpg',
      overlay: 'from-blue-600/80 via-purple-600/70 to-transparent'
    },
    {
      title: 'Cleaner Application',
      subtitle: 'Optimize Device Performance',
      image: 'https://readdy.ai/api/search-image?query=Clean%20abstract%20device%20optimization%20visualization%20with%20circular%20progress%20indicators%20and%20UI%20elements%2C%20light%20gray%20to%20white%20gradient%20background%2C%20floating%20geometric%20shapes%20representing%20storage%20and%20performance%20metrics%2C%20modern%20minimalist%20tech%20illustration%2C%20soft%20shadows%20and%20clean%20design%20elements&width=760&height=920&seq=product-cleaner-noliot-004&orientation=portrait',
      overlay: 'from-gray-800/60 via-gray-600/50 to-transparent'
    },
    {
      title: 'Integrated Experience',
      subtitle: 'Seamless iOS Integration',
      image: 'https://readdy.ai/api/search-image?query=Modern%20iPhone%20device%20mockup%20showing%20elegant%20app%20interface%20in%20purple%20blue%20duotone%20color%20treatment%2C%20sleek%20iOS%20application%20design%20with%20clean%20UI%20elements%2C%20professional%20mobile%20device%20showcase%20with%20app%20screens%2C%20premium%20tech%20product%20photography%20with%20gradient%20overlay&width=760&height=920&seq=product-integrated-noliot-005&orientation=portrait',
      overlay: 'from-indigo-600/80 via-purple-500/70 to-transparent'
    }
  ];

  return (
    <section id="products" className="py-32 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Our Core Products</h2>
          <p className="text-lg text-gray-600">Designed for iOS excellence</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {products.map((product, index) => (
            <div
              key={index}
              className="group relative h-[460px] rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="absolute inset-0">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-b ${product.overlay}`}></div>
              </div>
              <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-8">
                <h3 className="text-3xl font-bold text-white mb-3">{product.title}</h3>
                <p className="text-base font-light text-white/90">{product.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
